import { Col, Popover, Row } from 'antd';
import { ViewerInfo } from 'models/viewers';
import moment from 'moment';
import * as React from 'react';
import style from './ItemViewerList.module.scss';

export interface ItemViewerListProps {
  item: ViewerInfo;
  setIsShowViewersDetail: (value: boolean) => void;
  setItemViewer: (value: ViewerInfo) => void;
}

export default function ItemViewerList({
  item,
  setIsShowViewersDetail,
  setItemViewer,
}: ItemViewerListProps) {
  return (
    <Row
      onClick={() => {
        setIsShowViewersDetail(false);
        setItemViewer(item);
      }}
      className={style.root}
    >
      <Col className={style.item_viewer_label} span={7}>
        <Popover content={item.email}>{item.email}</Popover>
      </Col>
      <Col className={style.item_viewer_label} span={6}>
        <Popover content={moment(item.created_ts).format('YYYY-MM-DD HH:mm:ss')}>
          {moment(item.created_ts).format('YYYY-MM-DD HH:mm:ss')}
        </Popover>
      </Col>
      <Col className={style.item_viewer} span={7}>
        {item.first_name} {item.last_name}
      </Col>
      <Col className={style.item_viewer} span={4}>
        {item.status}
      </Col>
    </Row>
  );
}
